import { getExtensionsCode, getExtensionsMessages } from "@/lib/ts/graphql"
import { CancyCompanyAdminSubgraphUserErrorCode } from "@/souhl_admin/gql/__generated__/graphql"

import type { ApolloError } from "@apollo/client"
import type { GraphQLError } from "graphql"

/**
 * BAD_REQUESTエラーかどうかを判定する
 */
export const isBadRequestError = (graphqlError: GraphQLError): boolean => {
	const code = getExtensionsCode(graphqlError)
	return isCodeEquals(code, "BAD_REQUEST")
}

const isCodeEquals = (
	code: string | undefined,
	expectedCode: CancyCompanyAdminSubgraphUserErrorCode
): boolean => {
	return code === expectedCode
}

/**
 * ApolloErrorからBAD_REQUESTエラーのメッセージを取得する
 */
export const getBadRequestErrorMessages = (error: ApolloError): string[] => {
	const messages: string[] = []

	if (error.graphQLErrors) {
		error.graphQLErrors.forEach((graphqlError) => {
			if (isBadRequestError(graphqlError)) {
				const errorMessages = getExtensionsMessages(graphqlError)
				messages.push(...errorMessages)
			}
		})
	}

	return messages
}
